import React, { useMemo } from "react";
import { FaExclamationTriangle, FaTimes } from "react-icons/fa";
import FieldAppMaintenanceEditableHours from "./FieldAppMaintenanceEditableHours";
import {
  compareMaintenanceProximity,
  computeMaintenanceRemaining,
  formatMaintenanceRemaining,
} from "./maintenanceRemaining";

function formatMeter(value) {
  if (value == null || Number.isNaN(Number(value))) return "—";
  return Number(value).toLocaleString("pt-BR", { maximumFractionDigits: 1 });
}

export default function FieldAppMachineMaintenancesModal({
  machineName,
  rows,
  t,
  onClose,
  onSave,
  onComplete,
  onAdd,
}) {
  const sorted = useMemo(
    () => [...(rows || [])].sort(compareMaintenanceProximity),
    [rows]
  );

  if (!rows) return null;

  return (
    <div className="field-app-modal-backdrop" onClick={onClose}>
      <div
        className="field-app-modal field-app-machine-maintenances-modal"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="field-app-machine-maintenances-title"
      >
        <div className="field-app-modal-header">
          <h3 id="field-app-machine-maintenances-title">
            {t("Manutenções de {{machine}}", {
              machine: machineName || "—",
            })}
          </h3>
          <button
            type="button"
            className="close"
            onClick={onClose}
            aria-label={t("Fechar")}
          >
            <FaTimes aria-hidden />
          </button>
        </div>
        <p className="text-muted field-app-machine-maintenances-hint">
          {t(
            "Todas as revisões desta máquina. A coluna Faltam é calculada (alvo − leitura atual) e não se edita. Edite só a próxima manutenção com."
          )}
        </p>
        {onAdd ? (
          <div className="field-app-maintenance-toolbar field-app-maintenance-toolbar--modal">
            <button
              type="button"
              className="btn btn-sm btn-success"
              onClick={onAdd}
            >
              {t("Adicionar manutenção")}
            </button>
          </div>
        ) : null}
        <div className="table-responsive">
          <table className="table table-striped jambo_table field-app-maintenance-table">
            <thead>
              <tr>
                <th>{t("Tarefa")}</th>
                <th>{t("Status")}</th>
                <th title={t("Alvo programado menos a última leitura conhecida")}>
                  {t("Faltam")}
                </th>
                <th>{t("Próxima manutenção com")}</th>
                <th>{t("Leitura atual")}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {sorted.length === 0 ? (
                <tr>
                  <td colSpan="6">
                    {t("Nenhuma manutenção agendada para esta máquina.")}
                  </td>
                </tr>
              ) : (
                sorted.map((row) => {
                  const remaining = computeMaintenanceRemaining(row);
                  return (
                    <tr
                      key={row.id}
                      className={
                        row.isOverdue
                          ? "field-app-maintenance-row-overdue field-app-maintenance-row-overdue--scheduled"
                          : undefined
                      }
                    >
                      <td>{row.name || "—"}</td>
                      <td>
                        {row.isOverdue ? (
                          <span className="field-app-maintenance-status-overdue">
                            {t("Vencida")}
                          </span>
                        ) : (
                          row.status_display || row.status || "—"
                        )}
                      </td>
                      <td
                        className={
                          remaining.remaining != null && remaining.remaining < 0
                            ? "field-app-maintenance-current-overdue"
                            : undefined
                        }
                      >
                        {remaining.remaining != null && remaining.remaining < 0 ? (
                          <span className="field-app-maintenance-status-overdue">
                            <FaExclamationTriangle aria-hidden />{" "}
                            {formatMaintenanceRemaining(remaining, t)}
                          </span>
                        ) : (
                          formatMaintenanceRemaining(remaining, t)
                        )}
                      </td>
                      <td>
                        <FieldAppMaintenanceEditableHours
                          value={row.targetHourMeterDisplay}
                          field="targetHourMeter"
                          maintenanceId={row.id}
                          t={t}
                          onSave={onSave}
                          overdue={row.isOverdue}
                        />
                      </td>
                      <td>{formatMeter(row.currentHourMeterDisplay)}</td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-sm btn-success"
                          onClick={() => onComplete(row)}
                        >
                          {t("Concluir")}
                        </button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
